<script lang="ts">
	interface Props {
		title: string;
		value: string | undefined;
		truncateValue?: boolean;
	}

	const { title, value, truncateValue = false }: Props = $props();
</script>

{#if value}
	<div class="font-semibold text-coloredneutral">{title}</div>
	<div class={['text-right', truncateValue && 'truncate']}>{value}</div>
{/if}
